import React from "react";
import logo from "./quieromacLogo.jpg"; 

function LogoQuieromac({ onClick }) {
  return (
    <img
      src={logo}
      alt="QuieroMac Logo"
      width={87}
      height={50}
      onClick={onClick}
      style={{ cursor: 'pointer' }} 
    />
  );
}

export default LogoQuieromac;
